import React from "react";
import "./Sitemap.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import privacyImg from "../../Assets/privacy-policy.webp";
import { Link } from "react-router-dom";

const Sitemap = () => {
  return (
    <div>
      <Header />

      {/* banner section start */}
      <section
        className="container-fluid  site_map_section"
        style={{
          backgroundImage: `url(${privacyImg})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="banner_text">
                <h1>Sitemap</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end  */}

      {/* sitemap section start  */}
      <section className="container-fluid site_map_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_text text-center">
                <h2>Sitemap</h2>
              </div>
            </div>
          </div>
          <div className="row sitemap_row">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>Home</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>About Us</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/AboutUs" title="About Us">
                      About Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>Product</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/Product">Product</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>Contact</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/ContactUs">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>Privacy & Policy</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/PrivacyPolicy">Privacy & Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div className="title_text">
                <h3>Request A Quote</h3>
              </div>
              <div className="menu_text">
                <ul>
                  <li>
                    <Link to="/Request_A_Quote">Request A Quote </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* sitemap section End */}

      <Footer />
    </div>
  );
};

export default Sitemap;
